import React from 'react'
import { createRoot } from 'react-dom/client'
import { pageLanguage, siteUrls } from '../components/Data'
import { StaffConfig } from '../components/StaffPage/Config'

// <team-overview lang>: the team page's strip of video tiles and its lists of people by position.
// Loads the people itself. Without a shadow root: the lists are styled by iti.css.
export class TeamOverviewElement extends HTMLElement {
  connectedCallback () {
    const lang = this.getAttribute('lang') ?? pageLanguage();
    const mountPoint = document.createElement('div')
    mountPoint.className = 'team-main'   // the lists and the strip are styled under this name
    this.appendChild(mountPoint)
    createRoot(mountPoint).render(<StaffConfig lang={lang} urls={siteUrls(lang)} />)
  }
}
customElements.define('team-overview', TeamOverviewElement)
